import React from 'react';
import { Button, Form } from 'react-bootstrap';

export const RRSSform = ({rrss, setRRSS}) => {

    const changeName = (e, social) => {
        let copy = [...rrss];
        let index = rrss.findIndex(s => s.name === social.name)
        copy[index].name = e.target.value;
        setRRSS(copy);
    };

    const changeUrl = (e, social) => {
        let copy = [...rrss];
        let index = rrss.findIndex(s => s.name === social.name)
        copy[index].url = e.target.value;
        setRRSS(copy);
    }

  return (
    <>
    {
        rrss.map(social =>
            <div className="mb-3">
                <Form.Control type="text" maxLength="50" name="socialName" 
                autoComplete="nope" defaultValue={social.name}
                placeholder="Plataforma"
                onChange={(e) => changeName(e, social)}
                />
                <Form.Control type="text" maxLength="200" name="socialUrl" autoComplete="nope"
                 defaultValue={social.url}
                 placeholder="Cuenta"
                 onChange={(e) => changeUrl(e, social)}/>
                 <Button
                 variant="danger"
                 className="my-2"
                 onClick={() => setRRSS(rrss.filter(inp => inp.url !== social.url))}>
                     Eliminar red
                 </Button>
            </div>
            )
    }
    {(rrss.length === 0) && setRRSS([ {url: "", name:""}])
        
    }
    <Button 
    className="btn mt-0"
    onClick={() => setRRSS([...rrss, {url: "", name:""}])}>
        Añadir red social de la Provincia
    </Button>
    </>
);
};
